import { render, staticRenderFns } from "./SimulatorItem.vue?vue&type=template&id=312df08f&"
import script from "./SimulatorItem.vue?vue&type=script&lang=js&"
export * from "./SimulatorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports